import React from 'react'
import Button from '../Reusable/Button'

const TouchHome = () => {
return (
    <div  className='flex flex-col mt-6 z-[400]'>
        <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-2xl'></div>
        <div  className='flex lg:flex-row flex-col w-full justify-between z-[500] items-center'>
            <div data-aos="fade-right" className='lg:w-1/2 w-full text-white flex flex-col lg:items-start items-center gap-4'>
                <p className='lg:text-[48px] text-[30px] lg:text-start text-center font-bold text-white'>Start Your Conversation with <span className='text-[#2366CF]'>Blockfarms</span></p>
                <p className='lg:text-xl lg:text-start text-center'>Reach out for tailored support or inquiries. Our team is ready to assist you with your crypto mining needs, ensuring a personalized and responsive experience.</p>
                <Button
                    link={"allProducts"}
                    title={"See Products"}
                />
                <div>
                    <p className='lg:text-[25px] font-semibold text-white'>Trust by</p>
                    <div className='grid grid-cols-5'>
                        <img src="/Blockfarm/bitman.svg" alt="" />
                        <img src="/Blockfarm/iceriver.svg" alt="" />
                        <img src="/Blockfarm/jasminer.svg" alt="" />
                        <img src="/Blockfarm/canaan.svg" alt="" />
                        <img src="/Blockfarm/whatminner.svg" alt="" />
                    </div>
                </div>
            </div>
            <div data-aos={"fade-in"} className='lg:w-1/2 w-full lg:justify-end justify-center items-center flex relative'>
                <div className='absolute w-[600px] h-[600px] left-1 top-0 bg-blue-400 bg-opacity-10 rounded-full blur-2xl'></div>
                <img className='z-[500]' src="/Blockfarm/contact.svg" alt="" />
            </div>
        </div>

    </div>
)
}

export default TouchHome